<template>
    <div class="lby-task-item" @click="taskInfo" :class="{differential:isDifferent}" style="padding-left: 20px;">
      <div style="width: 100px;text-align: center;">{{itemIndex}}</div>
      <div style="width: 100px;text-align: center;">{{taskType}}</div>
      <div class="lby-task-detail" style="width: 660px;">{{task.description}}</div>
      <div style="width: 120px;">{{task.price}}￥</div>
      <div style="width: 200px;">{{task.updateTime}}</div>
    </div>
  </template>

<script>
export default {
  name: 'TaskItem',
  props: {
    task: {
      default: () => {
        return {}
      }
    },
    pageNo: {
      type: Number,
      default: 1
    },
    itemIndex: {
      type: Number
    },
    isDifferent: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    taskInfo () {
      this.$router.push({
        path: '/taskinfo',
        query: {
          taskId: this.task.id,
          taskPageNo: this.pageNo
        }
      })
    }
  },
  computed: {
    taskType () {
      if (this.$store.state.basicdata.taskTypeList.find(item => item.id === this.task.taskType) == null) {
        return '未知类型'
      }
      return this.$store.state.basicdata.taskTypeList.find(item => item.id === this.task.taskType).description
    }
  }
}
</script>

  <style scoped lang="less">
  .differential{
      background-color: #e7edf1;
    }
    .lby-task-item{
        display: flex;
        width: 100%;
        .lby-task-detail{
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  </style>
